// Drill-down helpers for the Category / Sub-Category / Behavior cascade.
// The tree itself comes from fetchBenchmarkTaxonomyApi (org-specific, fetched
// via getBenchmarkTaxonomy) — each node looks like:
//   CATEGORY:     { title, value, level, categoryName, children }
//   SUB_CATEGORY: { title, value, level, categoryName, subCategoryName, children }
//   BEHAVIOR:     { title, value, level, categoryName, subCategoryName, behaviorText }
// `value` (a unique "Category|Sub|Behavior" path) is used as the option key;
// `title` is the display label. categoryName/subCategoryName/behaviorText are
// sent as-is to getCommentsAndGist's `scope` payload.
export const ALL_SUBCATEGORIES = 'all';
export const ALL_BEHAVIORS = 'all';

export const getCategory = (taxonomy, key) =>
    (taxonomy || []).find((c) => c.value === key) || null;

export const getSubCategory = (category, key) =>
    !category || key === ALL_SUBCATEGORIES
        ? null
        : (category.children || []).find((s) => s.value === key) || null;

export const getBehavior = (subCategory, key) =>
    !subCategory || key === ALL_BEHAVIORS
        ? null
        : (subCategory.children || []).find((b) => b.value === key) || null;

export const categoryOptions = (taxonomy) =>
    (taxonomy || []).map((c) => ({ value: c.value, label: c.title }));

export const subCategoryOptions = (category) => [
    { value: ALL_SUBCATEGORIES, label: 'All sub-categories' },
    ...(category && category.children ? category.children.map((s) => ({ value: s.value, label: s.title })) : []),
];

export const behaviorOptions = (subCategory) => [
    { value: ALL_BEHAVIORS, label: 'All behaviors' },
    ...(subCategory && subCategory.children ? subCategory.children.map((b) => ({ value: b.value, label: b.title })) : []),
];

// The GIST tag's level label (e.g. "SUB-CATEGORY · COLLABORATION").
export const resolveScopeLevel = (subCategory, behaviorKey) => {
    if (subCategory && behaviorKey !== ALL_BEHAVIORS) return 'BEHAVIOR';
    if (subCategory) return 'SUB-CATEGORY';
    return 'CATEGORY';
};

export const HEADER_TEXT = {
    title: "Hear it in their words",
    description: 'Read a summary and representative comments for any category, sub-category, or behavior.'
}
